import { Injectable } from '@angular/core';
import { Role } from '../models/role.enum';
import { AuthService } from './Motor_leasing/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private authService: AuthService) { }

  has(permission: string): boolean {
    const user = this.authService.getUser();
    return user?.permissions?.includes(permission) ?? false;
  }

  hasAll(permissions: string[]): boolean {
    return permissions.every(p => this.has(p));
  }

  hasAny(permissions: string[]): boolean {
    return permissions.some(p => this.has(p));
  }

  getRole(): Role | null {
    return this.authService.getRole();
  }

  hasRole(role: Role): boolean {
    return this.getRole() === role;
  }

  hasAnyRole(roles: Role[]): boolean {
    const currentRole = this.getRole();
    return currentRole !== null && roles.includes(currentRole);
  }

  isAdmin(): boolean {
    const role = this.getRole();
    return [Role.TtAdmin, Role.LessorAdmin].includes(role!);
  }

  canAccess(expectedRoles: Role[], requiredPermissions: string[]): boolean {
    return this.hasAnyRole(expectedRoles) && this.hasAll(requiredPermissions);
  }

  readonly adminPermissions = ['TtCreate', 'TtRead', 'TtUpdate', 'TtDelete'];

  hasAdminPermissions(): boolean {
    return this.hasAll(this.adminPermissions);
  }
}
